import Routes from './Routes/Router.js';
export default function App() {
  return (
    <>
      <Routes />
    </>
  )
}